import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';

import {SKIP_WORKSPACE_HEADER} from '@app/core/api';
import {TokenService} from '@app/core/services/base';
import {WorkspaceType} from '@shared/enums/workspace.enum';
import {StoreService} from '@shared/services/store.service';
import {environment} from '@env/environment';

const WORKSPACE_HEADER = 'X-Workspace-Id';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const storeService = inject(StoreService);
  let headers = req.headers;
  const accessToken = tokenService.getAccessToken();
  if (accessToken) {
    headers = headers.set('Authorization', `Bearer ${accessToken}`);
  }
  headers = headers.set('X-Client-Version', environment.appVersion);
  const skipWorkspaceHeader = req.context.get(SKIP_WORKSPACE_HEADER);
  if (skipWorkspaceHeader) {
    if (headers.has(WORKSPACE_HEADER)) {
      headers = headers.delete(WORKSPACE_HEADER);
    }
  } else {
    const workspace = storeService.getCurrentWorkspace();
    if (workspace?.type === WorkspaceType.Assigned && workspace.id) {
      headers = headers.set(WORKSPACE_HEADER, workspace.id);
    } else if (headers.has(WORKSPACE_HEADER)) {
      headers = headers.delete(WORKSPACE_HEADER);
    }
  }
  return next(req.clone({headers}));
};
